<!--
  UIID: UI-Caas-MON-130
  UI Name: File View (popup)
  Modify Date: 2020/06/18
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    class="dialog-drag-display monitor-datainfo-layout-dialog"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text" primary-title>
        Data Information - {{ dataInfo.senderId }} / {{ dataInfo.recipientId }} /
        {{ dataInfo.messageName }} - {{ dataInfo.processId }}
      </v-card-title>
    </template>
    <template v-slot:button-close>
      <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon>
    </template>
    <!-- [S]  Popup body-->
    <v-card class="monitor-datainfo-layout-container">
      <v-card-text class="mb-2 pa-0">
        <v-row class="r-popup-content">
          <v-col cols="12" class="grid-pd">
            <v-row class="mt-0 status-section-mb">
              <v-col cols="12" sm="2" class="pr-0 pt-0 pb-0">
                Sender : <span>{{ dataInfo.senderId }}</span>
              </v-col>
              <v-col cols="12" sm="2" class="pr-0 pt-0 pb-0">
                Receiver : <span>{{ dataInfo.recipientId }}</span>
              </v-col>
              <v-col cols="12" sm="2" class="pr-0 pt-0 pb-0">
                Message : <span>{{ dataInfo.messageName }}</span>
              </v-col>
              <v-col cols="12" sm="2" class="pr-0 pt-0 pb-0">
                Partner : <span>{{ dataInfo.partnerName }}</span>
              </v-col>
              <v-col cols="12" sm="2" class="pr-0 pt-0 pb-0">
                Direction : <span>{{ directionText(dataInfo.direction) }}</span>
              </v-col>
              <v-col cols="12" sm="2" class="pr-0 pt-0 pb-0"> </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="r-popup-content">
          <v-col cols="12" sm="6" class="grid-pd">
            <v-row class="v-grid-title">
              <v-col class="pa-2">
                <span>Process Message</span>
              </v-col>
            </v-row>
            <v-row class="v-grid-content">
              <v-col class="pa-0">
                <v-row class="no-gutters">
                  <div class="CodeMirror">
                    <EDIViewer v-model="inputFileContents" :options="cmOption_in"></EDIViewer>
                    <!-- <input type="hidden" id="inputFileContentsHdn" /> -->
                  </div>
                </v-row>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6" class="grid-pd">
            <v-row class="v-grid-title">
              <v-col class="pa-2">
                <span>User Data</span>
              </v-col>
            </v-row>
            <v-row class="v-grid-content">
              <v-col class="pa-0">
                <v-row class="no-gutters">
                  <div class="CodeMirror">
                    <BIZViewer v-model="outputFileContents" :options="cmOption_out"></BIZViewer>
                    <!-- <input type="hidden" id="outputFileContentsHdn" /> -->
                  </div>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [S]  Popup footer-->
      <v-row class="ma-0">
        <v-col class="pa-0" lg="12">
          <v-row no-gutters>
            <v-col cols="12" lg="12" class="pt-0 pb-0">
              <div class="text-right">
                <v-btn x-small class="btn btn-delete" @click="removeDialog">
                  {{ $t('btn.common.close') }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- [E]  Popup footer-->
    </v-card>
  </dialog-drag>
</template>

<script>
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag2.vue';
import BIZViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import EDIViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import { mapState } from 'vuex';

// language
import 'codemirror/mode/swift/swift.js';

// theme css
import 'codemirror/theme/rubyblue.css';

// active-line.js
import 'codemirror/addon/selection/active-line.js';

// styleSelectedText
import 'codemirror/addon/selection/mark-selection.js';
import 'codemirror/addon/search/searchcursor.js';

// highlightSelectionMatches
import 'codemirror/addon/scroll/annotatescrollbar.js';
import 'codemirror/addon/search/matchesonscrollbar.js';
import 'codemirror/addon/search/searchcursor.js';
import 'codemirror/addon/search/match-highlighter.js';

// keyMap
import 'codemirror/mode/clike/clike.js';
import 'codemirror/addon/edit/matchbrackets.js';
import 'codemirror/addon/comment/comment.js';
import 'codemirror/addon/dialog/dialog.js';
import 'codemirror/addon/dialog/dialog.css';
import 'codemirror/addon/search/searchcursor.js';
import 'codemirror/addon/search/search.js';
import 'codemirror/keymap/sublime.js';

// foldGutter
import 'codemirror/addon/fold/foldgutter.css';
import 'codemirror/addon/fold/brace-fold.js';
import 'codemirror/addon/fold/comment-fold.js';
import 'codemirror/addon/fold/foldcode.js';
import 'codemirror/addon/fold/foldgutter.js';
import 'codemirror/addon/fold/indent-fold.js';
import 'codemirror/addon/fold/markdown-fold.js';
import 'codemirror/addon/fold/xml-fold.js';

var encoding = require('encoding');

export default {
  // props: ['id', 'title', 'options', 'eventCb', 'closeDialog', 'dragStart', 'dragEnd','inputFileLink','outputFileLink'],
  props: {
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    inputFileLink: String,
    outputFileLink: String,
    fileViewInfo: Object,
    dataInfo: Object,
  },
  components: {
    DialogDrag,
    EDIViewer,
    BIZViewer,
  },
  name: 'monitoring-file-view-window',

  data: () => ({
    absolute: true,
    overlayIn: false,
    overlayOut: false,
    inputFilePath: '',
    outputFilePath: '',
    inputFileContents: '',
    outputFileContents: '',
    encodingIn: '',
    encodingOut: '',
    encodings: [
      { text: 'Character Set', value: '' },
      { text: 'UTF-8', value: 'UTF-8' },
      { text: 'ASCII', value: 'ASCII' },
      { text: 'ISO-8859-1', value: 'ISO-8859-1' },
      { text: 'ISO-8859-15', value: 'ISO-8859-15' },
      { text: 'EUC-KR', value: 'EUC-KR' },
      { text: 'EUC-JP', value: 'EUC-JP' },
      { text: 'GB2312', value: 'GB2312' },
      { text: 'UTF-16LE', value: 'UTF-16LE' },
      { text: 'BASE64', value: 'BASE64' },
    ],
    cmOption_in: {
      tabSize: 4,
      lineWrapping: true,
      foldGutter: true,
      lineNumbers: true,
      line: true,
      readOnly: true,
      keyMap: 'sublime',
      mode: 'text/x-swift',
      theme: 'rubyblue',
      extraKeys: {
        F11(cm) {
          cm.setOption('fullScreen', !cm.getOption('fullScreen'));
        },
        Esc(cm) {
          if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false);
        },
      },
    },
    cmOption_out: {
      tabSize: 4,
      lineWrapping: true,
      foldGutter: true,
      lineNumbers: true,
      line: true,
      readOnly: true,
      keyMap: 'sublime',
      mode: 'text/x-swift',
      theme: 'rubyblue',
      extraKeys: {
        F11(cm) {
          cm.setOption('fullScreen', !cm.getOption('fullScreen'));
        },
        Esc(cm) {
          if (cm.getOption('fullScreen')) cm.setOption('fullScreen', false);
        },
      },
    },
    inMsg: '',
    outMsg: '',
  }),

  methods: {
    initialize() {
      let params = {};
      params = this.dataInfo;

      this.$store.dispatch('getinputFileContens', params.fileLink).then(() => {
        if (this.$store.getters.inputFileContents != null) {
          this.inputFileContents = this.convertFollowMessage(this.$store.getters.inputFileContents);
          this.outputFileContents = params.userData
            .split(`{`)
            .join('{\n')
            .split(`,`)
            .join(',\n')
            .split(`}`)
            .join('\n}')
            .split(`"`)
            .join('');
        }
      });
    },
    convertFollowMessage(input) {
      let replace = '';
      if (input.match(/^ISA\*/g)) {
        replace = input.replace(/~/g, '~\n');
      } else if (input.match(/^UNB\+/g) || input.match(/^\s*(?:UNA.{5}')?/g)) {
        replace = input.replace(/'/g, "'\n");
      } else {
        replace = input.replace(/'/g, '\n');
      }
      return replace;
      // return replace.replace(/\n\n/g, "\n");
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    directionText(direction) {
      if (direction === 'I') return 'Inbound';
      else if (direction === 'O') return 'Outbound';
    },
  },
  created() {
    this.initialize();
  },
};
</script>

<style>
.monitor-datainfo-layout-dialog {
  width: 1000px !important;
}
.monitor-datainfo-layout-dialog .v-card__text {
  font-size: 13px;
  line-height: 19px;
}
.monitor-datainfo-layout-dialog .v.grid-content {
  height: 528px;
  margin-bottom: 10px !important;
}
.monitor-datainfo-layout-container .CodeMirror-gutters {
  left: 0 !important;
}
.monitor-datainfo-layout-container .CodeMirror-gutter-wrapper {
  left: -36px !important;
}
.monitor-datainfo-layout-container .v-grid-title .v-input {
  height: auto !important;
}
.monitor-datainfo-layout-container .v-grid-title .v-input .v-input__slot {
  height: 40px !important;
}
.theme--light .monitor-datainfo-layout-container .v-grid-title .v-input {
  background: #ffffff;
}
.theme--dark .monitor-datainfo-layout-container {
  background-color: #2a2c35 !important;
}
.monitor-datainfo-layout-container .v-grid-content {
  height: 498px;
  background-color: #2a2c35;
  border: 3px solid #4e686f !important;
  padding: 0px;
}
.theme--dark .monitor-datainfo-layout-container .v-grid-title {
  height: 40px;
  width: 35%;
  background-color: #121212;
  border: 3px solid #4e686f !important;
  margin-top: 12.5px !important;
  margin-bottom: -8px !important;
}
.theme--light .monitor-datainfo-layout-container .v-grid-title {
  height: 40px;
  width: 35%;
  background-color: #ffffff;
  border: 3px solid #4e686f !important;
  margin-top: 30px !important;
  margin-bottom: -8px !important;
}
.theme--dark .monitor-datainfo-layout-container .v-grid-title .v-input {
  background: #2a2c35;
  border: none;
}
.theme--light span {
  font-family: Open Sans;
  font-style: normal;
  /* color:#000000; */
}
.theme--dark span {
  font-family: Open Sans;
  font-style: normal;
  color: #ffffff;
}
/* .dialogs .dialog-drag .dialog-body {
    padding-top: 30px !important;
    padding-left: 30px !important;
    padding-right: 30px !important;
    padding-bottom: 30px !important;
} */

.v-select {
  padding: 0 !important;
  /* 2021.01.14 - 202728 - issue common 39 */
  /* background:#2a2c35 !important; */
}
</style>
